// NOTE: header labels are stored in the database <db-name>.flow.work_order_list_column
const WO_COLUMNS = [
  {
    id: 'photo',
    alias: 'photo',
    isSortable: false,
    label: 'Photo',
    isVisible: true,
    style: { minWidth: 'auto', paddingRight: 0 },
  },
  {
    id: 'publicId',
    alias: 'jobId',
    isSortable: true,
    label: 'Job ID',
    isVisible: true,
    style: { minWidth: 'auto' },
  },
  {
    id: 'workOrderId',
    alias: 'workOrderId',
    isSortable: true,
    label: 'Work Order ID',
    isVisible: true,
    style: { minWidth: 'auto' },
  },
  {
    id: 'customer',
    alias: 'customerName',
    isSortable: false,
    label: 'Customer Name',
    isVisible: true,
    enabledForTechnicians: true,
  },
  { id: 'deviceStatus', alias: 'deviceStatus', isSortable: true, label: 'Device Status', isVisible: false },
  { id: 'makeTitle', alias: 'deviceMake', isSortable: true, label: 'Device Make', isVisible: true },
  {
    id: 'categoryTitle',
    alias: 'deviceCategory',
    isSortable: true,
    label: 'Device Category',
    isVisible: true,
  },
  { id: 'modelTitle', alias: 'deviceModel', isSortable: true, label: 'Device Model', isVisible: true },
  {
    id: 'deviceAssetId',
    alias: 'deviceAssetId',
    isSortable: true,
    label: 'Device Asset Id',
    isVisible: false,
  },
  { id: 'areaName', alias: 'areaName', isSortable: false, label: 'Area Name', isVisible: true },
  { id: 'woStatus', alias: 'jobStatus', isSortable: true, label: 'Job Status', isVisible: true },
  { id: 'lastActivity', alias: 'lastAction', isSortable: true, label: 'Last Action', isVisible: true },
  { id: 'schedule', alias: 'scheduleDate', isSortable: true, label: 'Schedule Date', isVisible: true },
  { id: 'createdAt', alias: 'daysOpen', isSortable: true, label: 'Days Open', isVisible: true },
  { id: 'facilityTitle', alias: 'facility', isSortable: true, label: 'Facility', isVisible: true },
  {
    id: 'facilityAddress',
    alias: 'facilityAddress',
    isSortable: false,
    label: 'Facility Address',
    isVisible: false,
    enabledForTechnicians: true,
  },
  {
    id: 'facilityCity',
    alias: 'facilityCity',
    isSortable: false,
    label: 'Facility City',
    isVisible: false,
    enabledForTechnicians: true,
  },
  {
    id: 'facilityZip',
    alias: 'facilityZip',
    isSortable: false,
    label: 'Facility Zip',
    isVisible: false,
    enabledForTechnicians: true,
  },
  {
    id: 'facilityContact',
    alias: 'facilityContactName',
    isSortable: false,
    label: 'Facility Contact Name',
    isVisible: false,
    enabledForTechnicians: true,
  },
  {
    id: 'accountAdmin',
    alias: 'accountAdminName',
    isSortable: false,
    label: 'Account Admin Name',
    isVisible: false,
    enabledForTechnicians: true,
  },
  {
    id: 'woDescription',
    alias: 'workOrderDescription',
    isSortable: false,
    label: 'Work Order Description',
    style: { maxWidth: 200 },
    isVisible: false,
  },
  {
    id: 'contractor',
    alias: 'contractorAssigned',
    isSortable: false,
    label: 'Contractor Assigned',
    isVisible: false,
    enabledForTechnicians: true,
  },
  {
    id: 'technicianCompany',
    alias: 'technicianCompany',
    isSortable: false,
    label: 'Technician Company',
    isVisible: false,
    enabledForTechnicians: false,
  },
];

export const WO_OPEN_HEADERS = [...WO_COLUMNS];

export const WO_COMPLETED_HEADERS = WO_COLUMNS.map((col) =>
  col.alias === 'daysOpen'
    ? { ...col, label: 'Days to Close', sortId: 'daysToComplete', style: { minWidth: 135, maxWidth: 145 } }
    : col
);

export const INITIALIZED_STATUS = 'initialized';
export const SERVICE_REQUESTED_STATUS = 'serviceRequested';
export const IN_PROGRESS_STATUS = 'inProgress';
export const SCHEDULED_STATUS = 'scheduled';
export const ON_REVIEW_STATUS = 'onReview';
export const COMPLETED_STATUS = 'completed';
export const CLOSED_STATUS = 'closed';
export const CANCELED_STATUS = 'canceled';
export const REJECTED_STATUS = 'rejected';
export const OPEN_STATUS = 'open';
export const BILLING_REVIEW_STATUS = 'billingReview';
export const COMPLETED_STATUS_ID = 2;
export const CANCELED_STATUS_ID = 17;
export const APPROVAL_REQUIRED_STATUS = 'approvalRequired';
export const LOW_PRIORITY = '1';

export const DATE_TYPES = {
  requestedDate: 'requestedDate',
  updatedAt: 'updatedAt',
  completedDate: 'completedDate',
};

export const OPENED_DATE_OPTIONS = [
  {
    label: 'Last activity',
    value: DATE_TYPES.updatedAt,
  },
  {
    label: 'Scheduled',
    value: DATE_TYPES.requestedDate,
  },
];

export const COMPLETED_DATE_OPTIONS = [
  {
    label: 'Completed',
    value: DATE_TYPES.completedDate,
  },
];

export const TYPES_OF_SERVICES = {
  PREVENTIVE_MAINTENANCE: '1',
  REPAIR: '2',
};

export const SERVICE_TYPE_MAPPER = {
  [TYPES_OF_SERVICES.PREVENTIVE_MAINTENANCE]: 'Preventive Maintenance',
  [TYPES_OF_SERVICES.REPAIR]: 'Repair',
};

export const SERVICE_TYPES = [
  {
    label: SERVICE_TYPE_MAPPER[TYPES_OF_SERVICES.PREVENTIVE_MAINTENANCE],
    value: TYPES_OF_SERVICES.PREVENTIVE_MAINTENANCE,
  },
  {
    label: SERVICE_TYPE_MAPPER[TYPES_OF_SERVICES.REPAIR],
    value: TYPES_OF_SERVICES.REPAIR,
  },
];

export const WO_PAYMENT_TYPES = [
  {
    label: 'None',
    value: 'none',
  },
  {
    label: 'Invoice',
    value: 'invoice',
  },
  {
    label: 'Electronically',
    value: 'electronically',
  },
];

export const WO_PAYMENT_TYPES_MAPPER = {
  NONE: 'none',
  INVOICE: 'invoice',
};

export const PM_TYPE = '1';

export const MAPPED_SERVICE_TYPES = {
  1: 'Preventive Maintenance',
  2: 'Repair',
};

export const STATUSES_OF_DEVICES = {
  UP: 'Up',
  DOWN: 'Down',
};

export const DEVICE_STATUS = [
  {
    label: 'Up',
    value: STATUSES_OF_DEVICES.UP,
  },
  {
    label: 'Down',
    value: STATUSES_OF_DEVICES.DOWN,
  },
];

export const MAPPED_DEVICE_STATUSES = {
  1: 'Up',
  2: 'Down',
};

export const COST_OF_SERVICE_PERFORMED = [
  {
    label: 'None',
    value: 'none',
  },
  {
    label: 'Warranty',
    value: 'warranty',
  },
  {
    label: 'Contract',
    value: 'contract',
  },
];

export const PRIORITIES = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  CRITICAL: 'critical',
};

export const PRIORITY_MAP = {
  1: PRIORITIES.LOW,
  2: PRIORITIES.MEDIUM,
  3: PRIORITIES.HIGH,
  4: PRIORITIES.CRITICAL,
};

export const PRIORITY = [
  {
    label: 'Low',
    value: '1',
  },
  {
    label: 'Medium',
    value: '2',
  },
  {
    label: 'High',
    value: '3',
  },
  {
    label: 'Critical',
    value: '4',
  },
];

export const JOB_STATUS = {
  ServiceRequested: 4,
  InProgress: 6,
  Cancelled: 17,
  Completed: 2,
};

export const JOB_STATUSES = [
  { value: JOB_STATUS.ServiceRequested, label: 'Service Requested' },
  { value: JOB_STATUS.InProgress, label: 'In Progress' },
];

export const REQUEST_WO_STATUSES = [
  'open',
  'serviceRequested',
  'inProgress',
  'scheduled',
  'onReview',
  'approvalRequired',
  'billingReview',
];

export const ERROR_ALIASES = {
  client: 'client',
  getMessage: 'getMessage',
  addMessage: 'addMessage',
  moreHistory: 'moreHistory',
  initChat: 'initChat',
  accessToken: 'accessToken',
};

export const LINEAR_FLOW_PROP = 'isLinear';

export const OPEN_STATUSES = [1, 4, 5, 6, 7, 20];
export const WO_COUNTER_STATUSES = [1, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 19, 20];

export const WO_REMOVED_STORAGE_KEY = 'wo-removed-ids';
export const WO_REMOVED_STORAGE_TTL = 1000 * 60 * 60;

export const ARRIVE_WINDOW = {
  EXACT: 0,
  '30_MIN': 30,
  '1_HOUR': 30 * 2,
  '2_HOURS': 30 * 2 * 2,
  '4_HOURS': 30 * 2 * 4,
  '8_HOURS': 30 * 2 * 8,
};

export const ARRIVE_WINDOW_OPTIONS = [
  { value: ARRIVE_WINDOW.EXACT, label: 'Exact' },
  { value: ARRIVE_WINDOW['30_MIN'], label: '30 minutes' },
  { value: ARRIVE_WINDOW['1_HOUR'], label: '1 hour' },
  { value: ARRIVE_WINDOW['2_HOURS'], label: '2 hours' },
  { value: ARRIVE_WINDOW['4_HOURS'], label: '4 hours' },
  { value: ARRIVE_WINDOW['8_HOURS'], label: '8 hours' },
];

export const PATTERSON_ARRIVE_WINDOW_OPTIONS = [
  { value: ARRIVE_WINDOW.EXACT, label: 'Exact' },
  { value: ARRIVE_WINDOW['2_HOURS'], label: '2 hours' },
  { value: ARRIVE_WINDOW['4_HOURS'], label: '4 hours' },
];

export const TECHNICIAN_FAVORITE_TIME_SETTING = 'technician_favorite_time';
export const TECHNICIAN_SHARE_WO_NOTES_SETTING = 'allow_to_share_wo_notes';

export const WO_STRATEGY = {
  DEVICE: 'device',
  AREA: 'area',
};

export const WO_STRATEGY_ID = {
  DEVICE: 1,
  AREA: 2,
};

export const WO_STRATEGIES_OPTIONS = [
  { value: WO_STRATEGY.DEVICE, label: 'Device' },
  { value: WO_STRATEGY.AREA, label: 'Area' },
];

export const WO_CHAT_CHANNEL_ALL = 'ALL';

export const FLOW_TYPES = {
  WORK_ORDER: 'workOrder',
  LOG: 'log',
  REPORT: 'report',
};

export const INTEGRATION_PROVIDERS = {
  PATTERSON: 'patterson',
};

export const INTEGRATION_SEGMENT = {
  VET: 'vet',
};
